export { default } from './Registration'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/Registration/index.js